(ns manage.poi.labels.ocps
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.poi :as poi.q]
            [common.widgets.form-field :refer [form-field]]
            [re-frame.core :as rf]
            [uix.core :refer [$]]
            [uix.re-frame :refer [use-subscribe]])
  (:require-macros [common.modal.view]
                   [common.ocp.view]))

(defocp create-label-ocp :poi/create-label {:width "25%"} [_props]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [control handleSubmit]} (form/use-form #js {:defaultValues #js {:name ""}})
        {create-label :mutate isPending :isPending} (use-mutation (poi.q/create-label-mutation {:advertiser-id advertiser-id}))
        on-submit (fn [^js data]
                    (create-label (->clj data)
                                  #js {:onSuccess (fn [_] (rf/dispatch [:ocp/close]))}))]
    ($ ocp {:title "New Label"
            :on-submit (handleSubmit on-submit)
            :footer ($ Button {:type "submit"
                               :variant "contained"
                               :disabled isPending}
                       "Create Label")}
       ($ form-field {:label "Name" :required? true}
          ($ form/form-text-field
             {:name "name"
              :control control
              :rules #js {:required "Name is required"
                          :pattern #js {:value #"^[a-zA-Z0-9\-_]+$"
                                        :message "Only letters, numbers, hyphens and underscores"}}})))))

(defmodal confirm-delete-label :poi/confirm-delete-label
  [{:keys [label-name locations selectors]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {delete-label :mutate} (use-mutation (poi.q/delete-label-mutation {:advertiser-id advertiser-id}))]
    (deletion-confirmation
     {:entity-name "Label"
      :item-label label-name
      :on-submit #(delete-label label-name
                                #js {:onSuccess (fn [_] (rf/dispatch [:ocp/close]))})
      :confirmation-message (str "This label is used by " locations " location(s) and " selectors " selector(s). Are you sure you want to delete it?")})))

(defocp label-ocp :poi/label {:width "25%"} [{:keys [label]}]
  ($ ocp {:title (:name label)}
     ($ Stack {:spacing 3}
        ($ form-field {:label "Name"}
           ($ TextField {:value (:name label)
                         :size "small"
                         :fullWidth true
                         :disabled true}))
        ($ Stack {:direction "row" :spacing 4}
           ($ Stack {:spacing 0.5}
              ($ Typography {:variant "body2" :fontWeight "600" :color "text.subtle"} "Locations")
              ($ Typography {:variant "body1"} (str (:locations label))))
           ($ Stack {:spacing 0.5}
              ($ Typography {:variant "body2" :fontWeight "600" :color "text.subtle"} "Selectors")
              ($ Typography {:variant "body1"} (str (:selectors label))))))))
